export class ReadableError extends Error {
  public constructor(public override message: string, public arg: any = null) {
    super(message);
  }
}
